import type { RootState } from '@/rootReducer';
import { shallowEqual, useSelector } from 'react-redux';

export const useTaskData = () => {
	const [isLoading, isSuccess, isError] = useSelector<
		RootState,
		[boolean, boolean, boolean]
	>(
		state => [
			state.dashboard.getIn(['taskModal', 'isLoading']),
			state.dashboard.getIn(['taskModal', 'failure']),
			state.dashboard.getIn(['taskModal', 'success'])
		],
		shallowEqual
	);

	return { isLoading, isSuccess, isError };
};
